module.exports = __webpack_public_path__ + "static/media/icon-financeiro.f1087514.svg";